import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export interface ISendFactorInfluenceInfoServiceArgs {
    id: string | number;
}

export const sendFactorInfluenceInfoService = async ({id}: ISendFactorInfluenceInfoServiceArgs) => (
    performRequest({
        url: `integration.module/ais3.factor.influence.info/send/${id}`,
        method: ERequestType.POST,
    })
);

